// src/ApiService/dashboardApi.js
export const dashboardApi = (api) => ({
  // Your endpoints:
  summary: (params) => api.get("HMCareDashboard/summary", params),

  // ✅ visits is under /HMCareDashboard/visits
  visits: (params) => api.get("HMCareDashboard/visits", params),

    // ✅ new: missed medication
  missedMedication: (params) => api.get("HMCareDashboard/missed-medication", params),

  exceptions: (params) => api.get("HMCareDashboard/exceptions", params),
  highRiskCustomers: (params) => api.get("HMCareDashboard/customers/high-risk", params),
  careplanReviews: (params) => api.get("HMCareDashboard/careplans/reviews", params),
  staffCapacity: (params) => api.get("HMCareDashboard/staff/capacity", params),
  finance: (params) => api.get("HMCareDashboard/finance", params),
});
